import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import type { ReactNode } from 'react';

export type MarketView = 'performance' | 'spend';

const OPTIONS: { value: MarketView; label: string }[] = [
  { value: 'performance', label: 'Performance' },
  { value: 'spend', label: 'Spend vs Savings' },
];

export function MarketViewToggle({
  value,
  onChange,
}: {
  value: MarketView;
  onChange: (value: MarketView) => void;
}): ReactNode {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        bgcolor: 'background.platform',
        borderRadius: 2,
        p: 0.5,
      }}
    >
      {OPTIONS.map((option) => {
        const selected = option.value === value;
        return (
          <ButtonBase
            key={option.value}
            data-test={`market-view-${option.value}`}
            onClick={() => onChange(option.value)}
            sx={(theme) => ({
              borderRadius: 1,
              py: 1,
              px: 2,
              fontSize: 11,
              fontWeight: 600,
              whiteSpace: 'nowrap',
              color: selected ? 'text.primary' : 'text.secondary',
              bgcolor: selected ? 'background.paper' : 'transparent',
              boxShadow: selected ? theme.shadows[3] : 'none',
            })}
          >
            {option.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
}
